"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CarouselWrapper = exports.Line5 = exports.Line4 = exports.Line3 = exports.Line2 = exports.Line1 = exports.responsiveStyles = void 0;

var _uiKit = require("@dbi-tools/ui-kit");

var _const = require("../../const");

var _helpers = require("../../helpers");

var _heroSlide = require("./slide-a/hero-slide.styled");

var _heroSlideContent = require("./slide-b/hero-slide-content/hero-slide-content.styled");

var _heroSlideUi = require("./slide-b/hero-slide-ui.styled");

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  min-height: 650px;\n\n  ", " {\n    ", "\n  }\n\n  ", " {\n    flex: 1;\n  }\n\n  ", " {\n    flex: 1;\n\n    ", " {\n      min-height: auto;\n    }\n  }\n\n  .slick-slider & {\n    min-height: 650px;\n    ", " {\n      ", " {\n        height: 100%;\n      }\n    }\n\n    ", " {\n      ", " {\n        ", " {\n          min-height: calc(650px - 211px);\n        }\n      }\n    }\n  }\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n            ", " {\n              background-image: url(", ");\n            }\n\n            ", " {\n              background-image: url(", ");\n            }\n          "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    background-image: ", ";\n    background-color: transparent;\n    background-size: cover;\n    background-position: center;\n\n    ", "\n\n    ", "\n    ", "\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n          ", " {\n            background-image: url(", ");\n          }\n        "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n          ", " {\n            background-image: url(", ");\n          }\n        "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var responsiveStyles = function responsiveStyles(_ref) {
  var _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items;
  var images = items.reduce(function (obj, _ref2) {
    var visible = _ref2.visible,
        image = _ref2.image;

    if (obj || obj.hasOwnProperty(visible)) {
      return obj[visible] = encodeURI(image) || '', obj;
    }
  }, {});
  var tabletImage = images.tablet || images.desktop;
  var styleTablet = images && tabletImage ? (0, _uiKit.css)(_templateObject(), _uiKit.GridBreakpointsMediaDown.lg, tabletImage) : '';
  var styleMobile = images && images.mobile ? (0, _uiKit.css)(_templateObject2(), _uiKit.GridBreakpointsMediaDown.sm, images.mobile) : '';
  return (0, _uiKit.css)(_templateObject3(), images && images.desktop ? "url(".concat(images.desktop, ")") : "", images && images.desktop ? (0, _uiKit.css)(_templateObject4(), _const.GridBreakpointsMediaDownCustom.xxl, images.desktop, _uiKit.GridBreakpointsMediaDown.md, images.desktop) : "", images && tabletImage ? styleTablet : '', images && images.mobile ? styleMobile : '');
};

exports.responsiveStyles = responsiveStyles;
var Line1 = (0, _uiKit.styled)('div')(_templateObject5(), function (_ref3) {
  var styles = _ref3.theme.styles;
  return styles ? (0, _helpers.lineStyles)({
    styles: styles,
    line: 'line1'
  }) : '';
});
exports.Line1 = Line1;
var Line2 = (0, _uiKit.styled)('div')(_templateObject6(), function (_ref4) {
  var styles = _ref4.theme.styles;
  return styles ? (0, _helpers.lineStyles)({
    styles: styles,
    line: 'line2'
  }) : '';
});
exports.Line2 = Line2;
var Line3 = (0, _uiKit.styled)('div')(_templateObject7(), function (_ref5) {
  var styles = _ref5.theme.styles;
  return styles ? (0, _helpers.lineStyles)({
    styles: styles,
    line: 'line3'
  }) : '';
});
exports.Line3 = Line3;
var Line4 = (0, _uiKit.styled)('div')(_templateObject8(), function (_ref6) {
  var styles = _ref6.theme.styles;
  return styles ? (0, _helpers.lineStyles)({
    styles: styles,
    line: 'line4'
  }) : '';
});
exports.Line4 = Line4;
var Line5 = (0, _uiKit.styled)('div')(_templateObject9(), function (_ref7) {
  var styles = _ref7.theme.styles;
  return styles ? (0, _helpers.lineStyles)({
    styles: styles,
    line: 'line5'
  }) : '';
}); // styles for components in carousel

exports.Line5 = Line5;
var CarouselWrapper = (0, _uiKit.styled)("div")(_templateObject10(), _uiKit.GridBreakpointsMediaDown.sm, function (_ref8) {
  var is50Block = _ref8.is50Block;
  return is50Block && "min-height: 600px;";
}, _heroSlide.HeroSlideStyled, _heroSlideUi.HeroSlideStyled, _uiKit.GridBreakpointsMediaDown.sm, _heroSlideUi.HeroImageBlock, _uiKit.GridBreakpointsMediaDown.md, _heroSlideUi.HeroSlideStyled, _uiKit.GridBreakpointsMediaDown.sm, _heroSlideContent.HeroSlideContentStyled);
exports.CarouselWrapper = CarouselWrapper;